import React from 'react';
import styled from 'styled-components';
import images from '../../Theming/images';

const Logo = styled.img``;

const ItvSquareLogo: React.FC<React.CSSProperties> = ({ ...rest }) => {
  return (
    <Logo
      id="itv-logo"
      src={images.ItvX.default}
      alt="Itv logo"
      style={{ ...rest }}
    />
  );
};

ItvSquareLogo.defaultProps = {
  height: 15,
};
export default ItvSquareLogo;
